import type { Lens } from './types.js';

export const RESUME_KEY = 'sm_resume';

export type ResumePoints = Partial<Record<Lens, string>>;

export function readResume(storage?: Pick<Storage, 'getItem'>): ResumePoints {
  try {
    const raw = storage?.getItem(RESUME_KEY);
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return {};
    const out: ResumePoints = {};
    for (const lens of ['day', 'best', 'people'] as Lens[]) {
      const value = (parsed as Record<string, unknown>)[lens];
      if (typeof value === 'string') out[lens] = value;
    }
    return out;
  } catch {
    return {};
  }
}

export function writeResume(points: ResumePoints, storage?: Pick<Storage, 'setItem'>): void {
  try {
    storage?.setItem(RESUME_KEY, JSON.stringify(points));
  } catch {
    // Storage can be unavailable; resuming is a convenience, not a requirement.
  }
}

/** A resume point only counts while the item is still in the manifest (US-11). */
export function validResume(points: ResumePoints, lens: Lens, knownIds: Iterable<string>): string | undefined {
  const id = points[lens];
  if (!id) return undefined;
  const known = knownIds instanceof Set ? knownIds : new Set(knownIds);
  return known.has(id) ? id : undefined;
}
